import { types, actions } from './requests'
export const DELETEOFFICE_TYPES = {
    ...types('DELETEOFFICE')
}
export const DELETEOFFICE_ACTIONS = {
    ...actions('DELETEOFFICE')
}
